export const hasFreeStudyAccess = (appToBuild: string): boolean =>
  appToBuild === "ibew_aptitude";

interface ReferralInviteInput {
  appHasReferralProgram: boolean;
  isPaidReferrer: boolean;
  flagEnabled: boolean;
}

export const canShowReferralInvite = ({
  appHasReferralProgram,
  isPaidReferrer,
  flagEnabled,
}: ReferralInviteInput): boolean =>
  appHasReferralProgram && isPaidReferrer && flagEnabled;

interface PlumbingRedSealReferralTrialNoticeInput {
  appToBuild: string;
  referralTrialActive: boolean;
  selectedStateCode?: string | null;
  redSealStateCode: string;
  hasPaidStudyAccess: boolean;
}

export const shouldShowPlumbingRedSealReferralTrialNotice = ({
  appToBuild,
  referralTrialActive,
  selectedStateCode,
  redSealStateCode,
  hasPaidStudyAccess,
}: PlumbingRedSealReferralTrialNoticeInput): boolean =>
  appToBuild === "plumbing" &&
  referralTrialActive &&
  // The referral trial record stays active for its full 24h even after the
  // user buys a subscription — paid access must win over the trial notice.
  !hasPaidStudyAccess &&
  Boolean(selectedStateCode) &&
  selectedStateCode !== redSealStateCode;
